<template>
  <div class="dragonIndex">
    <!-- 视频 -->
    <div class="videoWrap">
      <div class="videoMaxWidth">
        <div class="videoBg">
          <div class="video">
            <div class="videoContent">
              <Carousel radius-dot dots="outside">
                <CarouselItem>
                  <video :src="getVideoUrl('VIDEO/CD/1.mp4')" controls="controls">
                    您的浏览器不支持 video 标签。
                  </video>
                </CarouselItem>
                <CarouselItem>
                  <video :src="getVideoUrl('VIDEO/CD/2.mp4')" controls="controls">
                    您的浏览器不支持 video 标签。
                  </video>
                </CarouselItem>
                <CarouselItem>
                  <video :src="getVideoUrl('VIDEO/CD/3.mp4')" controls="controls">
                    您的浏览器不支持 video 标签。
                  </video>
                </CarouselItem>
                <CarouselItem>
                  <video :src="getVideoUrl('VIDEO/CD/4.mp4')" controls="controls">
                    您的浏览器不支持 video 标签。
                  </video>
                </CarouselItem>
                <CarouselItem>
                  <video :src="getVideoUrl('VIDEO/CD/5.mp4')" controls="controls">
                    您的浏览器不支持 video 标签。
                  </video>
                </CarouselItem>
                <CarouselItem>
                  <video :src="getVideoUrl('VIDEO/CD/6.mp4')" controls="controls">
                    您的浏览器不支持 video 标签。
                  </video>
                </CarouselItem>
                <CarouselItem>
                  <video :src="getVideoUrl('VIDEO/CD/7.mp4')" controls="controls">
                    您的浏览器不支持 video 标签。
                  </video>
                </CarouselItem>
                <CarouselItem>
                  <video :src="getVideoUrl('VIDEO/CD/8.mp4')" controls="controls">
                    您的浏览器不支持 video 标签。
                  </video>
                </CarouselItem>
              </Carousel>
            </div>
          </div>
        </div>
        <div class="videoBottom bottm1"></div>
        <div class="videoBottom bottm2"></div>  
      </div>
    </div>
    <div class="banner">
      <img class="bannerImg" src="/img/changDu/banner2022.jpg" alt="">
    </div>
    <!-- 轮播图 -->
    <!-- <div class="banner">
      <Carousel radius-dot autoplay :autoplay-speed="5000" loop>
        <CarouselItem>
          <div>
            <img class="bannerImg" src="/img/changDu/banner.jpg" alt="">
          </div>
        </CarouselItem>
        <CarouselItem>
          <div>
            <img class="bannerImg" src="/img/changDu/banner.jpg" alt="">
          </div>
        </CarouselItem>
        <CarouselItem>
          <div>
            <img class="bannerImg" src="/img/changDu/banner.jpg" alt="">
          </div>
        </CarouselItem>
      </Carousel>
    </div> -->
    <!-- 奖项简介 -->
    <!-- <div class="dragonStatic">
      <div class="bigTitle">
        <span class="redBdbtm">奖项简介</span>
      </div>
      <p class="indent">“设计为人民服务”奖项是由光华设计基金会授权，旨在表彰以设计为手段，推动公益设计发展、社会进步的杰出人物，以及优秀公益产品和服务。“设计为人民服务”为光华设计基金会汇聚设计行业力量，向社会提供各类公益服务的系列活动，涵盖设计扶贫、设计公益教育、设计为乡村、设计公益品、设计助力地方发展等内容。</p>
      <p class="center mgBtmLg"><Button class="moreBtn" to="/chang_du/about">了解更多>></Button></p>
    </div> -->
    <!-- 参赛类别 -->
    <div class="bgGray">
      <div class="dragonStatic">
        <div class="bigTitle">
          <span class="redBdbtm">参赛类别</span>
        </div>
        <Row :gutter="50">
          <!-- 非遗类
          红色文化类
          特产商品类 -->
          <!-- <Col :lg="{span: 8}" :sm="{span:12}">
            <div class="settingWrap">
              <img class="itemImg" src="/img/changDu/c1.png" alt="">
              <div class="itemText">生活创意类</div>
            </div>
          </Col>
          <Col :lg="{span: 8}" :sm="{span:12}">
            <div class="settingWrap">
              <img class="itemImg" src="/img/changDu/c2.png" alt="">
              <div class="itemText">IP文旅类</div>
            </div>
          </Col> -->
          <!-- <Col :lg="{span: 8}" :sm="{span:12}">
            <div class="settingWrap">
              <img class="itemImg" src="/img/changDu/c3.png" alt="">
              <div class="itemText">非遗类</div>
            </div>
          </Col>
          <Col :lg="{span: 8}" :sm="{span:12}">
            <div class="settingWrap">
              <img class="itemImg" src="/img/changDu/c4.jpg" alt="">
              <div class="itemText">红色文化类</div>
            </div>
          </Col> -->
          <Col :lg="{span: 12}" :sm="{span:12}">
            <div class="settingWrap">
              <img class="itemImg" src="/img/changDu/c6.png" alt="">
              <div class="itemText">旅游纪念品</div>
            </div>
          </Col>
          <Col :lg="{span: 12}" :sm="{span:12}">
            <div class="settingWrap">
              <img class="itemImg" src="/img/changDu/c8.jpg" alt="">
              <div class="itemText">数字创意类设计作品</div>
            </div>
          </Col>
          <!-- <Col :lg="{span: 8}" :sm="{span:12}">
            <div class="settingWrap">
              <img class="itemImg" src="/img/changDu/c6.png" alt="">
              <div class="itemText">微电影、小视频创意类</div>
            </div>
          </Col> -->
        </Row>
      </div>
    </div>
    <!-- 奖项设置 -->
    <div class="dragonStatic">
      <div class="bigTitle">
        <span class="redBdbtm">奖项设置</span>
      </div>
      <Row :gutter="50" class="center">
        <!-- <Col :lg="{span: 6}" :sm="{span:12}" :xs="{span:12}">
          <div class="pdTB">
            <img src="/img/changDu/1.jpg" alt="">
            <div class="bold awardText">
              <p>“光华龙腾奖-</p>
              <p>设计为人民服务特别奖”</p>  
            </div>
          </div>
        </Col> -->
        <Col :lg="{span: 6}" :sm="{span:12}" :xs="{span:12}">
          <div class="pdTB">
            <img src="/img/changDu/2.jpg" alt="">
            <p class="bold awardText">“最佳文创作品奖”</p>
          </div>
        </Col>
        <Col :lg="{span: 6}" :sm="{span:12}" :xs="{span:12}">
          <div class="pdTB">
            <img src="/img/changDu/3.jpg" alt="">
            <p class="bold awardText">“优秀奖”</p>
          </div>
        </Col>
        <Col :lg="{span: 6}" :sm="{span:12}" :xs="{span:12}">
          <div class="pdTB">
            <img src="/img/changDu/7.png" alt="">
            <p class="bold awardText">“入围奖”</p>
          </div>
        </Col>
        <Col :lg="{span: 6}" :sm="{span:12}" :xs="{span:12}">
          <div class="pdTB">
            <img src="/img/changDu/5.jpg" alt="">
            <p class="bold awardText">“优秀组织奖”</p>
          </div>
        </Col>
        <!-- <Col :lg="{span: 8}" :sm="{span:12}" :xs="{span:12}">
          <div class="pdTB">
            <img src="/img/changDu/1.jpg" alt="">
            <p class="bold awardText">“光华龙腾奖·设计为人民服务特别奖”</p>
          </div>
        </Col>
        <Col :lg="{span: 8}" :sm="{span:12}" :xs="{span:12}">
          <div class="pdTB">
            <img src="/img/changDu/2.jpg" alt="">
            <p class="bold awardText">“最佳文创作品奖”</p>
          </div>
        </Col>
        <Col :lg="{span: 8}" :sm="{span:12}" :xs="{span:12}">
          <div class="pdTB">
            <img src="/img/changDu/3.jpg" alt="">
            <p class="bold awardText">“入围奖”</p>
          </div>
        </Col>
        <Col :lg="{span: 8}" :sm="{span:12}" :xs="{span:12}">
          <div class="pdTB">
            <img src="/img/changDu/4.jpg" alt="">
            <p class="bold awardText">“最佳人气奖”</p>
          </div>
        </Col>
        <Col :lg="{span: 8}" :sm="{span:12}" :xs="{span:12}">
          <div class="pdTB">
            <img src="/img/changDu/5.jpg" alt="">
            <p class="bold awardText">“优秀组织奖”</p>
          </div>
        </Col>
        <Col :lg="{span: 8}" :sm="{span:12}" :xs="{span:12}">
          <div class="pdTB">
            <img src="/img/changDu/6.jpg" alt="">
            <p class="bold awardText">“优秀青少年设计奖”</p>
          </div>
        </Col> -->
      </Row>
    </div>
    <!-- 参赛指南 -->
    <div class="bgRed">
      <div class="dragonStatic">
        <div class="bigTitle">
          <span class="redBdbtm">参赛指南</span></div>
        <Row :gutter="80">
          <Col :lg="{span: 24}" :sm="{span:24}" :xs="{span:24}">
            <p class="subTitle bold">参赛对象</p>
            <p>面向全国致力于文化创意设计和研发的企业、机构、院校、设计公司和设计师，发明人、专利持有人、工艺美术师、手工艺制作者、艺术从业者、设计爱好者、学生等均可参赛，也可以共同创作、联名参赛。</p>
          </Col>
          <!-- <Col :lg="{span: 12}" :sm="{span:12}" :xs="{span:24}">
            <p class="subTitle bold">大赛组别</p>
            <p>大赛分为专业组、高校组和社会组</p>
            <p>• 专业组：职业设计师、设计企业。</p>
            <p>• 高校组：教师、学生（个人或团体）。</p>
            <p>• 社会组：设计爱好者。</p>
          </Col> -->
        </Row>
      </div>
    </div>
    <!-- 机构&媒体 -->
    <div class="dragonStatic">
      <div class="bigTitle">
        <span class="redBdbtm">机构&媒体</span>
      </div>
      <p class="bold blackSubTitle">1）组织机构</p>
      <p class="bold">主办单位：</p>
      <p class="mgBtm">昌都市人民政府、天津市对口支援西藏工作前方指挥部</p>
      <!-- <p class="bold">协办单位：</p>
      <p class="mgBtm">天津市工业设计协会、天津市设计学学会、天津商业大学、天津美术学院、河北工业大学、四川美术学院、北京市设计学学会、河北省工业设计协会、浙江省工业设计协会、广东省工业设计协会</p> -->
      <p class="bold">承办单位：</p>
      <p class="mgBtm">西藏昌都旅游发展局、北京龙腾生态绿色设计研究院有限公司</p>
      <p class="bold">支持单位：</p>
      <p class="mgBtm">西藏昌都市文化局（西藏昌都市文物局）、光华设计基金会、北京大学、中央美术学院、清华美术学院、北京师范大学、北京工业大学、北京建筑大学、北京科技大学、湖南大学、天津工业大学、河北科技大学、南开大学、同济大学、浙江大学、中国传媒大学、京津冀创新设计产业联盟等</p>
      <p class="bold blackSubTitle">2）媒体支持</p>
      <p class="mgBtmLg">光明网、环球网、中华网、央广网、国际在线、中国经济报、新浪网、凤凰网、网易、今日头条、腾讯网、长城网、中国名牌、搜狐北青网、中青网等</p>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {
    window.onload = function() {
      var videos = document.getElementsByTagName("video"); //获取所有video
      //循环给所有video添加监听事件 当前的video开始播时  调用pauseAll 将当前播放的video的索引传值过去
      for (var i = videos.length - 1; i >= 0; i--) {
        (function(n) {
          videos[n].addEventListener("play", function() {
            pauseAll(n);
          });
        })(i);
      }
      //接收调用传来的索引 循环所有video 索引与传来的索引不相同的 暂停 重载
      function pauseAll(index) {
        for (var j = videos.length - 1; j >= 0; j--) {
          if (j != index) {
            videos[j].pause();
            videos[j].load();
          }
        }
      }
    };
  }
};
</script>


<style lang="scss" scoped>
.dragonIndex {
  font-size: 16px;
  line-height: 1.8em;

  .videoMaxWidth {
    max-width: 1100px;
    margin: auto;
  }
  .videoWrap {
    background: linear-gradient(
      145deg,
      #f5f5f5 0%,
      #f5f5f5 30%,
      #d9472e 30%,
      #d9472e 45%,
      #cb1c21 45%,
      #cb1c21 100%
    );
    padding: 50px 0 80px;
    .videoBg {
      position: relative;
      margin: 0 10%;
      background: #091e33;
      border-radius: 5px 5px 0 0;
      padding: 30px 15px 15px;
      &::after {
        content: "";
        position: absolute;
        top: 12px;
        left: 50%;
        width: 6px;
        height: 6px;
        border-radius: 6px;
        background: #cac6c7;
        margin-left: -3px;
      }
      .video {
        padding-bottom: 60%;
        position: relative;
        .videoContent {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          border: 1px solid rgba($color: #fff, $alpha: 0.1);
          video {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .bottm1 {
      height: 15px;
      background: #ffffff;
    }
    .bottm2 {
      height: 10px;
      background: #f7f7f7;
      border-radius: 0 0 100px 100px;
    }
  }
  .banner {
    font-size: 0;
    padding: 100px 20%;
    background: #f7f7f7;
    .bannerImg {
      width: 100%;
    }
  }
  .bigTitle {
    border-bottom: 1px solid #cf271c;
    font-size: 28px;
    color: #cf271c;
    text-align: center;
    font-weight: 600;
    margin: 0 100px 30px;
    padding-top: 50px;
    .redBdbtm {
      display: inline-block;
      border-bottom: 3px solid #cf271c;
      padding-bottom: 15px;
    }
  }
  .indent {
    text-indent: 32px;
  }
  .moreBtn {
    color: #cf271c;
    border-color: #cf271c;
    font-weight: 600;
    margin-top: 20px;
  }
  .bgGray {
    background: #f7f7f7;
    padding-bottom: 50px;
  }
  .settingWrap {
    border: 1px solid #b5b5b5;
    padding: 5px;
    text-align: center;
    margin-bottom: 30px;
    .itemImg {
      width: 100%;
    }
    .itemText {
      padding: 5px 0;
      font-weight: 600; // font-size: 18px;
    }
  }
  .pdTB {
    padding-top: 30px;
    padding-bottom: 20px;
  }
  .awardText {
    height: 3.8em;
  }
  .bgRed {
    background: #ca1b20;
    padding-bottom: 50px;
    color: #ffffff;
    .bigTitle {
      border-bottom: 1px solid #fff;
      color: #ffffff;
      .redBdbtm {
        border-bottom: 3px solid #ffffff;
      }
    }
    .subTitle {
      font-size: 20px;
      text-align: center;
      padding-bottom: 15px;
    }
  }
  .blackSubTitle {
    font-size: 20px;
    padding-bottom: 10px;
  }
  .mgBtm {
    margin-bottom: 15px;
  }
  .mgBtmLg {
    margin-bottom: 50px;
  }
}
@media (max-width: 1200px) {
  .dragonIndex {
    .videoMaxWidth {
      max-width: 900px;
    }
    .banner {
      padding-left: 15%;
      padding-right: 15%;
    }
    .bigTitle {
      margin-left: 50px;
      margin-right: 50px;
    }
  }
}
@media (max-width: 992px) {
  .dragonIndex {
    overflow-x: hidden;
    .videoMaxWidth {
      max-width: 700px;
    }
    .videoWrap {
      padding: 30px 0;
    }
    .banner {
      padding: 50px 10%;
    }
    .bigTitle {
      margin-left: 30px;
      margin-right: 30px;
    }
  }
}
@media (max-width: 768px) {
  .dragonIndex {
    .videoMaxWidth {
      max-width: 90%;
    }
    .banner {
      padding-left: 15px;
      padding-right: 15px;
    }
    .bgRed .subTitle {
      margin-top: 20px;
    }
  }
}
</style>